import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  position: absolute;
  bottom: 0;
  left: 0;

  width: 100%;
`;

export const Path = styled.path`
  transition: 0.25s stroke;
`;

const Stroke = ({ color = "black", pathRef }: { color?: string, pathRef?: React.RefObject<SVGPathElement> }) => (
  <Wrapper
    viewBox="0 0 135 10"
  >
    <Path
      ref={pathRef}
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={5}
      vectorEffect="non-scaling-stroke"
      d="M3.1 4.5c42.5-5.4 86.3 6.1 128.9.9"
    />
  </Wrapper>
);

export default Stroke;